import React from 'react'
import { CalendarCheck, StopCircle } from 'react-bootstrap-icons'
import {
  TimelineActionLabel,
  TimelineActionProviderIcon,
} from './timelineActionDisplay'

function ScenarioAssetTitle({ asset, dimmed, passed, showAuthUsername }) {
  const scenarioStateClass = passed
    ? 'text-rb-lighter-grey dark:text-gray-400'
    : dimmed
      ? 'opacity-50'
      : ''
  return (
    <div className={`flex min-w-0 items-center gap-2 overflow-hidden ${scenarioStateClass}`}>
      <TimelineActionProviderIcon
        asset={asset}
        className={`text-sm ${passed ? 'text-rb-lighter-grey dark:text-gray-400' : ''}`}
        style={passed ? { color: '#9ca3af' } : undefined}
      />
      <TimelineActionLabel
        asset={asset}
        passed={passed}
        showAuthUsername={showAuthUsername}
        className={`text-sm font-medium ${
          passed ? scenarioStateClass : 'dark:text-white'
        }`}
      />
    </div>
  )
}

export default function AssetListItemTitle({
  asset,
  variant = 'scenario',
  dimmed = false,
  passed = false,
  showAuthUsername = true,
}) {
  const dimClass = dimmed ? 'opacity-50' : ''
  const projectTitleStateClass = passed
    ? 'text-rb-lighter-grey dark:text-gray-400'
    : dimClass
  const ProjectIcon = passed ? CalendarCheck : StopCircle
  const authLabel =
    showAuthUsername && asset.auth_username != null && asset.auth_username !== ''
      ? `${asset.auth_username} - `
      : ''

  if (variant === 'scenario') {
    return (
      <ScenarioAssetTitle
        asset={asset}
        dimmed={dimmed}
        passed={passed}
        showAuthUsername={showAuthUsername}
      />
    )
  }

  return (
    <div className="flex min-w-0 items-center gap-1 overflow-hidden">
      <ProjectIcon
        className={`shrink-0 text-xs ${projectTitleStateClass}`}
        style={passed ? undefined : { color: asset.theme_color }}
      />
      <h4
        className={`min-w-0 flex-1 truncate text-sm dark:text-white ${projectTitleStateClass}`}
        title={`${authLabel}${asset.name}`}
      >
        {authLabel}
        {asset.name}
      </h4>
    </div>
  )
}
